<template>
  <div class="search">
    <div class="search-box">
      <input
        type="text"
        v-model="keyword"
        @input="keywordInput"
        @blur="blurInput"
        @focus="keywordInput"
        placeholder="请搜索型号或者相关信息"
      />
      <div class="icon">
        <img src="../assets/images/tabbar/sousuohei@2x.png" alt />
      </div>
      <span class="close-btn" v-show="closeShow" @click="deleteText">
        <van-icon name="close" />
      </span>
      <span @click="toSearchResult">搜索</span>
    </div>
    <!-- 热门搜索 -->
    <div class="hot-search">
      <div class="title">
        <div class="icon">
          <img src="../assets/images/search/remen@2x.png" alt />
        </div>
        <span>热门搜索</span>
      </div>
      <div class="content">
        <ul>
          <li
            v-for="(item,index) in hotSearchList"
            :key="index"
            @click="searchWord(item.keyword)"
          >{{item.keyword}}</li>
        </ul>
      </div>
    </div>
    <!-- 最近搜索 -->
    <div class="hot-search recent-search">
      <div class="title">
        <div class="icon">
          <img src="../assets/images/search/zuijin@2x.png" alt />
        </div>
        <span>最近搜索</span>
        <div class="clear" v-if="recentWords.length > 0" @click="deleteHistory">
          <img src="../assets/images/search/ssshangchu.png" alt />
        </div>
      </div>
      <div class="content">
        <ul>
          <li v-for="(item,index) in recentWords" :key="index" @click="searchWord(item)">{{item}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { prodPopular } from "../request/api";
export default {
  name: "Search",
  data() {
    return {
      keyword: "",
      closeShow: false,
      recentWords: [], //最近搜索
      hotSearchList: [] //热门搜索
    };
  },
  created() {
    this.getHistoryWords();
    this.getHotSearch();
  },
  methods: {
    //   获取热门搜索
    getHotSearch() {
      prodPopular({}).then(res => {
        this.hotSearchList = res.data;
      });
    },
    keywordInput() {
      // 如果有关键字则显示删除按钮，否则隐藏
      this.closeShow = this.keyword ? true : false;
    },
    // 失去焦点时删除按钮消失
    blurInput() {
      this.closeShow = false;
    },
    // 删除搜索词
    deleteText() {
      this.keyword = "";
      this.closeShow = false;
    },
    // 获取历史搜索词
    getHistoryWords() {
      let arr = localStorage.getItem("histroyWords");
      if (arr) {
        this.recentWords = arr.split(",");
      }
    },
    // 删除历史记录
    deleteHistory() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除历史记录"
        })
        .then(() => {
          localStorage.removeItem("histroyWords");
          this.recentWords = [];
        })
        .catch(() => {
          // on cancel
        });
    },
    searchWord(item) {
      this.$router.push({
        name: "searchResult",
        params: {
          keyword: item
        }
      });
    },
    //搜索
    toSearchResult() {
      let str = this.keyword.trim();
      if (str.length <= 0) {
        this.$toast("请输入产品或相关型号");
      } else {
        // 判断历史记录
        let searchWord = localStorage.getItem("histroyWords");
        if (searchWord == null) {
          //判断是否存在历史搜索记录，如果不存 ，则添加
          localStorage.setItem("histroyWords", str);
          this.recentWords.unshift(str);
        } else {
          // 如果存在，拿到历史记录，判断是否有重复，有就不添加，没有就添加
          let arr = localStorage.getItem("histroyWords");
          arr = arr.split(",");
          if (arr.indexOf(str) != -1) {
            arr = arr;
          } else {
            arr.unshift(str);
          }
          this.recentWords = arr;
        }
        localStorage.setItem("histroyWords", this.recentWords);
        // 跳转到搜索页并携带keyword参数
        this.$router.push({
          name: "searchResult",
          params: {
            keyword: str
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.search {
  width: 100%;
  height: 100%;
  background: #fff;
}
.search-box {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  font-size: 30px;
  input {
    width: 613px;
    height: 50px;
    padding: 30px 0;
    line-height: 50px;
    font-size: 26px;
    background: #f5f5f5;
    border-radius: 8px;
    padding-left: 70px;
    box-sizing: border-box;
    border: solid 1px #dcdcdc;
    margin-right: 15px;
  }
  .icon {
    position: absolute;
    left: 47px;
    top: 28px;
    width: 36px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  span {
    color: #333;
  }
  .close-btn {
    position: absolute;
    right: 120px;
    top: 30px;
  }
}
// 热门搜索
.hot-search {
  width: 100%;
  padding-top: 30px;
  border-top: 1px solid #f1f1f1;
  .title {
    color: #999;
    font-size: 30px;
    padding-left: 30px;
    margin-bottom: 30px;
    .icon {
      width: 32px;
      height: 32px;
      vertical-align: bottom;
      margin-right: 5px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content {
    padding: 0 30px;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        padding: 15px;
        background: #f5f5f5;
        border-radius: 8px;
        font-size: 26px;
        color: #333;
        margin: 0 20px 20px 0;
      }
    }
  }
}
.recent-search {
  border: none;
  padding-top: 120px;
  .title {
    .clear {
      float: right;
      width: 30px;
      height: 30px;
      margin-right: 30px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>